/* This file path & variable name is closely integrated with 'scripts/generateAppJson.js'  */

export const LOCAL_VERSION_NUMBER = '2.4.6'
export const LOCAL_BUILD_NUMBER = '100'

const MAIN_WEBSITE = `https://www.emma-live.com/`

// Pusher config

const PUSHER_APP_KEY = `5538b1dff3e360930871`
const PUSHER_APP_CLUSTER = `eu`
const PUSHER_APP_ENCRYPTED = true

// Common class name across the app
export const CSS_CLASS = {
	IMAGE_ASPECT_RATIO: 'aspect-video', // In tailwind it's 16:9
}

export default {
	MAIN_WEBSITE,
	PAGINATION_PAGE_SIZE_OPTIONS: [25, 100, 250, 500],
	DEBOUNCE_TIME: 500,
	CSS_CLASS,
	PHONE_MIN_LEN: 11,
	MIN_PASSWORD_LEN: 6,
	PUSHER_CONFIG: {
		PUSHER_APP_KEY,
		PUSHER_APP_CLUSTER,
		PUSHER_APP_ENCRYPTED,
	},
}
